import React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseSelect } from '../shared/BaseSelect/BaseSelect';
import { UserAvatar } from '../UserAvatar/UserAvatar';

import styles from './ReferralProviderSelect.module.scss';

export const ReferralProviderSelect = ({ options, onChange, value, hasError = false, ...otherProps }) => {
  const { t } = useTranslation('common');
  const formatOptionLabel = ({ provider }) => {
    if (!provider) return null;

    return (
      <p className={styles.yourInfoValue}>
        <UserAvatar name={provider?.full_name} />
        <span>{provider?.full_name}</span>
        <span className={styles.yourInfoValueEmail}>{provider?.email}</span>
      </p>
    );
  };

  return (
    <BaseSelect
      placeholder={t('placeholders.select')}
      onChange={(option) => onChange(option)}
      value={options.find((opt) => opt.value === value) || null}
      options={options}
      isClearable={false}
      formatOptionLabel={formatOptionLabel}
      hasError={hasError}
      menuMaxHeight="300px"
      {...otherProps}
    />
  );
};
